import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const interactionModalContent = style([
  {
    maxWidth: 550,
  },
]);

export const interactionModalTitle = style([
  {
    width: '100%',
    justifyContent: 'center',
  },
]);

export const interactionModalDescription = style([
  {
    color: themeVars.container.foreground.secondary,
    textAlign: 'center',
    marginTop: space.s6,
  },
]);

export const interactionModalAction = style([
  {
    width: 'auto',
    margin: `${space.s40}px ${space.s24}px 0`,
  },
]);
